import { jsx as _jsx } from "react/jsx-runtime";
import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef';
import { getDataTestId } from '@/js/libs/utils/get-data-test-id';
import { StyledItem } from './styled';
export const Item = ({ option, selectedValue, columns, index, totalCount, allDisabled, isOptionSelected, onChange, formatOptionLabel, }) => {
    const { value, disabled: optionDisabled, label } = option;
    const checked = isOptionSelected ? isOptionSelected(value, selectedValue) : value === selectedValue;
    const disabled = allDisabled || optionDisabled;
    const handleChange = useCallbackRef(() => {
        if (!disabled) {
            onChange(value);
        }
    });
    return (_jsx(StyledItem, { "$checked": checked, disabled: disabled, "$allDisabled": allDisabled, "$columns": columns, "$index": index, "$totalCount": totalCount, onClick: handleChange, tabIndex: disabled ? -1 : 0, "data-testid": getDataTestId(label, `${value}${checked ? '-selected' : ''}`), children: formatOptionLabel ? formatOptionLabel(option) : label }));
};
